import { types } from 'mobx-state-tree'

import { AdobeTimelineEvent } from './AdobeTimelineEvent'

const model = types
  .model('RawHTML', {
    Type: types.literal('RawHTML'),
    objectId: types.identifier,
    fileName: types.string,
    fileExt: types.string,
    src: types.string,
    totalFrames: types.number,
    labels: types.maybeNull(types.array(AdobeTimelineEvent)),
    animationWidth: types.number,
    animationHeight: types.number,
    animationFPS: types.number,
    dateTime: types.maybeNull(types.string),
    size: types.maybeNull(types.number),
    userName: types.maybeNull(types.string),
  })

export default model
